<!-- home-page.vue -->
<template>
  <Layout>
    <div v-if="loading" class="mx-auto flex flex-col justify-center items-center h-screen">
      <img :src="loadingImage" alt="Loading..." class="" />
    </div>
    <!-- Optional: Fullscreen overlay -->
    <AnnouncementMedia :images="announcementImages" v-if="announcementImages?.length > 0"/>
    <AnnouncementBanner :announcements="announcements" v-if="announcements?.length > 0" />
     <div class="px-4 py-8 sm:px-6 md:py-12 lg:px-16">
    <div class="w-3/4 ">
      <h2 class="text-3xl sm:text-[40px] font-[900] mb-6 capitalize text-left">About</h2>
      <p class="mt-2 text-lg font-[500] text-black text-left">The history of Shri Goghari Lohana Mahajan dates back to 1842-43 when a large number of Goghari Lohanas from several parts of Gujarat including Bhavnagar, Babara, Dhulera and Amreli set base in Mumbai. On 13th March, 1854, Sheth Shri Harji Jina Bogha, one of the richest traders in cotton at that time, founded the Jina Bogha Wadi in Kalbadevi, Mumbai. The base was set and Shri Goghari Lohana Mahajan Wadi thus began its activities to over a hundred Lohana families.</p>
    </div>
  </div> 
    <HomeServices v-if="serviceLinkLists" :serviceItems="serviceLinkLists" />
    <HomeEvents v-if="upcomingEventsLinkList" :eventItems="upcomingEventsLinkList"/>
    <HomeCirculars v-if="circularLinkList" :circularItems="circularLinkList" />
    <HomeSandesh v-if="sandeshLinkList" :sandeshItems="sandeshLinkList" />
  </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue';
import HomeServices from '@/components/sections/HomeServices.vue';
import HomeEvents from '@/components/sections/HomeEvents.vue';
import AnnouncementBanner from './../banners/AnnouncementBanner.vue';
import AnnouncementMedia from './../banners/AnnouncementMedia.vue';
import HomeCirculars from '@/components/sections/HomeCirculars.vue';
import HomeSandesh from '@/components/sections/HomeSandesh.vue';
import axiosInstance from '@/utils/axiosInstance';

import loading from '@/assets/krishna-loading.jpg';

export default {
  components: {
    Layout,
    AnnouncementBanner,
    AnnouncementMedia,
    HomeServices,
    HomeEvents,
    HomeCirculars,
    HomeSandesh
  },
  data() {
    return {
      ourServicesHeader: "Our Services",
      serviceLinkLists: [],
      circularsHeader: "Circulars",
      circularLinkList: [],
      sandeshHeader: "Sandesh",
      sandeshLinkList: [],
      photoGalleryHeader: "Photo Gallery",
      photoGalleryLinkList: [],
      upcomingEventsHeader: "Forthcoming Events",
      upcomingEventsLinkList: [],
      announcements: [],
      announcementImages: [],
      announcementIndex: 0,
      loading: true, // Initialize loading state
      loadingImage: loading,
    };
  },
  computed: {
    currentAnnouncement() {
      if (!this.announcements || this.announcements.length === 0) {
      return '';
    }
    return this.announcements[this.announcementIndex].bannertext;


    },
  },
  async created() {
    try {
      this.loading = true; // Start loading
      const response = await axiosInstance.get('home-page?populate[serviceLinkList][populate]=linkMedia&populate[announcementsbanner][populate]=*&populate[bannerimage][populate]=*&populate[circularLinkList][populate]=*&populate[sandeshLinkList][populate]=*&populate[photogallerylinklist][populate]=*&populate[upcomingEventsLinkList][populate]=*');
      const responseAttributes = response.data.data.attributes;
      console.log(responseAttributes);
      
      this.announcements = responseAttributes.announcementsbanner || [];
      this.announcementImages = (responseAttributes.bannerimage?.data || []).map(img => img.attributes.url);
      
      this.serviceLinkLists = (responseAttributes.serviceLinkList || []).map(item => ({
        ...item,
        linkMedia: item.linkMedia?.data?.[0]?.attributes?.url || ''
      }));
      
      this.circularLinkList = (responseAttributes.circularLinkList || []).map(item => ({
        ...item,
        linkMedia: item.linkMedia?.data?.attributes?.url || ''
      }));
      
      this.sandeshLinkList = (responseAttributes.sandeshLinkList || []).map(item => ({
        ...item,
        linkMedia: item.linkMedia?.data?.attributes?.url || ''
      }));
      
      this.photoGalleryLinkList = responseAttributes.photogallerylinklist || [];
      
      this.upcomingEventsLinkList = (responseAttributes.upcomingEventsLinkList || []).map(item => ({
        ...item,
        linkMedia: item.linkMedia?.data?.[0]?.attributes?.url || '',
        linkImage: item.linkImage?.data?.attributes?.url || ''
      }));
    } catch (error) {
      console.error('Failed to fetch announcements:', error);
      // Optionally, you could set an error state here to show a message to the user
    } finally {
      this.loading = false; // Stop loading regardless of outcome
    }
  },
};

</script>
  